/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { IAuthenticationState, IRetrievedTokenData } from "./types";
import { PayloadAction } from "@reduxjs/toolkit";
import { getUserDetails, isJwtExpired } from "../../../utils/helpers";
import { LOCAL_STORAGE } from "../../../globals/globals";
import { setCookie, deleteCookie } from "../../../utils/cookie";


export const loginAction = (state: IAuthenticationState, action: PayloadAction<IRetrievedTokenData>) => {
  const loginData = action.payload;

  if (!loginData || isJwtExpired(loginData.idToken)) {
    logoutAction(state);
    //window.history.replaceState({}, "", ROUTES.LOGIN.Path);
    return;
  }

  // We should check here just to verify the Profile ID from the token matches the Profile ID
  //  of the Profile object that was returned by the authentication controller,
  const { profileId, username } = getUserDetails(loginData.idToken);
  if (profileId !== loginData.profile?.id) {
    // This is bad news, someone is trying some funny business!
    logoutAction(state);
    //window.history.replaceState({}, "", ROUTES.LOGIN.Path);
    return;
  }

  // * Refresh Tokens should be stored in local storage so that
  //   they will be persisted through a browser refresh
  localStorage.setItem(LOCAL_STORAGE.REFRESH_TOKEN, loginData.refreshToken);
  localStorage.setItem(LOCAL_STORAGE.TOKEN, loginData.idToken);
  localStorage.setItem(LOCAL_STORAGE.PROFILE, JSON.stringify(loginData.profile));
  localStorage.setItem(LOCAL_STORAGE.USER, username);

  // Clear potential stale cookie scoped to /ssh before setting current token.
  // Some browsers may prefer a more specific path cookie during /ssh requests.
  document.cookie = LOCAL_STORAGE.JWTCOOKIE + '=; path=/ssh; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
  // Domain-scoped cookie so the JWT is sent to proxy-<deviceId> device subdomains.
  setCookie(LOCAL_STORAGE.JWTCOOKIE, loginData.idToken);
  document.cookie = LOCAL_STORAGE.JWTCOOKIE + '=' + loginData.idToken + '; path=/ssh;';

  state.username = username;
  state.profileId = profileId;
  state.profile = loginData.profile;
  state.isLoggedIn = true;
  state.idToken = loginData.idToken;
  state.refreshToken = loginData.refreshToken;
};

export const logoutAction = (state: IAuthenticationState) => {
  Object.values(LOCAL_STORAGE).forEach((key) => localStorage.removeItem(key));

  // Remove JWT and SSH activity cookies
  if (LOCAL_STORAGE.JWTCOOKIE) {
    deleteCookie(LOCAL_STORAGE.JWTCOOKIE);
    document.cookie = LOCAL_STORAGE.JWTCOOKIE + '=; path=/ssh; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
  }
  if (LOCAL_STORAGE.SSHACTIVITYCOOKIE) {
    document.cookie = LOCAL_STORAGE.SSHACTIVITYCOOKIE + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT;';
  }

  state.username = "";
  state.isLoggedIn = false;
  state.idToken = undefined;
  state.refreshToken = undefined;
  state.profile = undefined;
  state.profileId = 0;
};

